import { defineStore } from "pinia";

export const useCatalogPublishingGroupsStore = defineStore("CatalogPublishingGroupsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchPublishingGroups(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/publishing_groups?q[name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchPublishingGroup(id) {
      try {
        const response = await this.$axios.get(`api/v1/catalog/publishing_group/${id}`);
        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
